import { Container } from "@mui/material";
import FacebookIcon from "@mui/icons-material/Facebook";
import InstagramIcon from "@mui/icons-material/Instagram";
import LinkedInIcon from "@mui/icons-material/LinkedIn";
import React from "react";

import "./footer.scss";

const productLinks = [
  { href: "/furniture-packages", label: "Furniture Packages" },
  { href: "/electronic-appliances", label: "Electronic Appliances" },
  { href: "/computer-peripherals", label: "Computer Peripherals" },
  { href: "/recreational-setups", label: "Recreational Setups" },
  { href: "/commercial-fitness", label: "Commercial Fitness" },
  { href: "/food-and-beverages", label: "Food & Beverages" },
  { href: "/products", label: "All Products" },
];

const usefulLinks = [
  { href: "/contact-us", label: "Contact Us" },
  { href: "/faqs", label: "FAQs" },
  { href: "/blog", label: "Blog" },
  { href: "/about-us", label: "About Us" },
  { href: "/careers", label: "Careers" },
  { href: "/case-studies", label: "Case Studies" },
];

const Footer = () => {
  const currentYear = new Date().getFullYear();

  return (
    <footer className="footer-container" aria-label="Site footer">
      <Container maxWidth="lg">
        <div className="footer-content-container">
          {/* Brand */}
          <div className="footer-brand">
            <img
              src="https://d5r8zwzwkh326.cloudfront.net/new+ui+images/settlrs-transparent-logo.png"
              alt="Settlrs – Business Equipment Rental"
              width="140"
              height="40"
              loading="lazy"
            />
            <p className="footer-tagline">
              Leasing as a service for commercial products. Helping businesses
              go Capex-lite across India.
            </p>
            <div className="social-icons" aria-label="Social media links">
              <a
                href="https://www.instagram.com/settlrs/"
                target="_blank"
                rel="noopener noreferrer"
                aria-label="Settlrs on Instagram"
              >
                <InstagramIcon className="social-icon" />
              </a>
              <a
                href="https://www.linkedin.com/company/settlrs/about/"
                target="_blank"
                rel="noopener noreferrer"
                aria-label="Settlrs on LinkedIn"
              >
                <LinkedInIcon className="social-icon" />
              </a>
              <a
                href="https://www.facebook.com/settlrs/"
                target="_blank"
                rel="noopener noreferrer"
                aria-label="Settlrs on Facebook"
              >
                <FacebookIcon className="social-icon" />
              </a>
            </div>
          </div>

          {/* Products */}
          <div className="footer-col">
            <h4>Products</h4>
            <ul>
              {productLinks.map((link) => (
                <li key={link.href}>
                  <a href={link.href}>{link.label}</a>
                </li>
              ))}
            </ul>
          </div>

          {/* Useful Links */}
          <div className="footer-col">
            <h4>Company</h4>
            <ul>
              {usefulLinks.map((link) => (
                <li key={link.href}>
                  <a href={link.href}>{link.label}</a>
                </li>
              ))}
            </ul>
          </div>

          {/* Contact */}
          <div className="footer-col">

            <h4>Reach Us</h4>
            <address>
              3rd Floor, Clayworks, Shankara Foundation
              <br />
              Kanakapura Rd, Bengaluru 560062
              <br />
              <a href="tel:+917892295893">+91 7892295893</a>
              <br />
              <a href="mailto:info@settlrs.com">info@settlrs.com</a>
            </address>
          </div>
        </div>
      </Container>

      <div className="footer-bottom">
        <Container maxWidth="lg">
          <div className="footer-bottom-inner">
            <span className="copyright">
              &copy; {currentYear} Settlrs Venture Pvt. Ltd.
            </span>
            <div className="footer-bottom-links">
              <a href="/terms-and-conditions">Terms</a>
              <a href="/privacy-policy">Privacy</a>
            </div>
          </div>
        </Container>
      </div>
    </footer>
  );
};

export default Footer;